import React, { Component, Fragment } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Button from '../../artzu-ui/src/Button';

import { ValidatorForm } from 'react-form-validator-core';
import TextInput from './TextInput';
import AutzuLogoLayout from './AutzuLogoLayout';
import './login.css';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      fb_access_token: '',
      fb_id: '',
      login_error: ''
    };
  }

  componentDidMount() {
    // this.props.history.push('/downloadapp');
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ login_error: nextProps.error });
  }

  handleChange = ({ target }) => {
    const { name } = target;
    const val = target.value;

    this.setState({ [name]: val });
  };

  handleSubmit = () => {
    this.props.tryLogin(this.state, this.props.history);
  };

  facebookCallback = response => {
    this.props.tryLogin(
      {
        email: response.email,
        fb_access_token: response.accessToken,
        fb_id: response.id
      },
      this.props.history
    );
  };

  login = () => {
    const { email, password, login_error } = this.state;
    return (
      <Fragment>
        <Helmet>
          <title>Login | Autzu</title>
        </Helmet>
        <AutzuLogoLayout>
          <ValidatorForm
            className="login__form"
            instantValidate={false}
            onSubmit={() => this.handleSubmit()}>
            <div className="login__inputs">
              <TextInput
                floatingLabelText="Email"
                onChange={this.handleChange}
                name="email"
                value={email.trim().replace(/\s/g, '')}
                validators={['required', 'isEmail']}
                errorMessages={[
                  'This field is required',
                  'Email is not valid'
                ]}
              />
              <TextInput
                style={{
                  marginLeft: '0',
                  paddingLeft: '3rem',
                  width: '31.5rem'
                }}
                floatingLabelText="Password"
                name="password"
                onChange={this.handleChange}
                value={password}
                type="password"
                validators={['required']}
                errorMessages={['This field is required']}
              />

              <p style={{ color: 'red' }}>{login_error}</p>
              <Link to="/forgot"> Forgot your password? </Link>
            </div>
            <div className="login__button">
              <Button
                size="xl"
                primary
                fullWidth
                type="submit"
                label="Log In"
              />

              <p className="login__signup">
                Don't have an account?{' '}
                <Link to="/signup" label="Sign Up.">
                  Sign Up.
                </Link>
              </p>
            </div>
          </ValidatorForm>
        </AutzuLogoLayout>
      </Fragment>
    );
  };

  render() {
    const { loggedIn } = this.props;
    if (loggedIn) {
      return <Redirect to="/dashboard" />;
    }
    return this.login();
  }
}
export default Login;



// WEBPACK FOOTER //
// ./src/components/User/Login.js